import './JobPage.scss';
import JobPageContent from './JobPageContent';
import JobPageLoader from './JobPageLoader';

export default function JobPage() {
  return (
    <JobPageLoader>
      <JobPageContent />
    </JobPageLoader>
  );
}
